import { zodResolver } from '@hookform/resolvers/zod';
import { useForgotPassword } from 'features/auth/hooks/useForgotPassword';
import { forgotPasswordSchema } from 'features/auth/schemas/forgotPassword.schema';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import Image from 'components/AppImage';

const ForgotPassword = () => {
  const { mutate: forgotPassword, isPending } = useForgotPassword();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(forgotPasswordSchema),
    mode: 'onChange',
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = (data) => {
    forgotPassword(data);
  };

  return (
    <div className='min-h-screen flex items-center justify-center bg-background px-4 bg-admin'>
      <div className='max-w-md w-full space-y-8'>
        {/* Header */}
         <div className='text-center'>
          <div className='admin-logo'>
            <Image
                src='/assets/images/logo.svg'
                alt='Qkly Logo'                
              />
          </div>

        </div>

        <div className='form-content'>
           <h2 className='text-2xl font-bold text-foreground text-center'>Forgot Password</h2>
          <p className='mt-2 text-center text-black'>
            Enter your email address and we'll send you a link to reset your password
          </p>
          {/* Forgot Password Form */}
          <form className='mt-8 space-y-6' onSubmit={handleSubmit(onSubmit)}>
            <div className='space-y-4'>
              {/* Email Field */}
              <div>
                <label htmlFor='email' className='block text-sm font-medium text-foreground mb-1'>
                  Email Address
                </label>
                <Input
                  id='email'
                  type='email'
                  placeholder='Enter your email'
                  disabled={isPending}
                  {...register('email')}
                />
                {errors.email && <p className='mt-1 text-sm text-red-500'>{errors.email.message}</p>}
              </div>
            </div>

            {/* Submit Button */}
            <Button type='submit' className='w-full' disabled={isPending}>
              {isPending ? (
                <>
                  <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2' />
                  Sending...
                </>
              ) : (
                <>
                  <Icon name='Mail' size={16} className='mr-2' />
                  Send Reset Link
                </>
              )}
            </Button>

            {/* Back to Login Link */}
            <div className='text-center'>
              <Link to='/login' className='text-sm text-primary hover:underline inline-flex items-center gap-1'>
                <Icon name='ArrowLeft' size={14} />
                Back to Login
              </Link>
            </div>
          </form>
        </div>


      </div>
    </div>
  );
};

export default ForgotPassword;
